import styled from 'styled-components';

export const StyledUserMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;

  .ant-dropdown {
    .ant-dropdown-menu {
      padding: 6px 0;
      border-radius: 8px;
      text-align: left;
    }

    .ant-dropdown-menu-item {
      padding: 8px 16px;
      gap: 10px;
      white-space: nowrap;

      &:hover {
        color: ${({ theme }) => theme.colors.mainOrange};

        .anticon,
        svg,
        span,
        label {
          color: ${({ theme }) => theme.colors.mainOrange};
        }
      }
    }
  }
`;
